import _ from 'lodash';
import {
    FETCH_AI_CHATBOT_QUESTIONS,
    CLEAN_AI_CHATBOT_QUESTIONS,
    DELETE_AI_CHATBOT_QUESTION,
    DELETE_AI_CHATBOT_QUESTIONS,
    EDIT_AI_CHATBOT_QUESTION,
} from './types';
import { request, __ } from '../functions';

export const fetchAiChatbotQuestions = (screen, message_id, options = {}) => {
    const defaults = {
        page: 1,
        per_page: 0,
        filtered: {},
    };

    options = { ...defaults, ...options };

    let params = { page: options.page, per_page: options.per_page };

    // Nasetujeme filter
    _.forEach(options.filtered, (value, key) => {
        params = { ...params, ...{ [`filter_${key}`]: value } };
    });

    return dispatch => request(`/ai-chatbot-questions/index/${message_id}`, params).then(response => {
        const { data, sync } = response.data;
        const { setUser } = screen.props;

        // Nasetujeme user data
        setUser(sync.user);

        dispatch({ type: FETCH_AI_CHATBOT_QUESTIONS, payload: data });
    });
};

export const editAiChatbotQuestion = (screen, id, language, input, output) => {
    return dispatch => request(`/ai-chatbot-questions/edit/${id}`, { language, input, output }, 'POST').then(response => {
        const { status } = response.data;

        if (status === 'error') {
            screen.showSnackbar('error', __('Nepodarilo sa upraviť otázku'));
            return;
        }

        screen.showSnackbar('success', __('Otázka bola upravená'));

        dispatch({ type: EDIT_AI_CHATBOT_QUESTION, payload: { id, language, input, output } });
    });
};

export const deleteAiChatbotQuestion = (screen, id) => {
    return dispatch => request(`/ai-chatbot-questions/delete/${id}`).then(response => {
        const { status } = response.data;

        if (status === 'error') {
            screen.showSnackbar('error', __('Nepodarilo sa zmazať otázku'));
            return;
        }

        screen.showSnackbar('success', __('Otázka bola zmazaná'));

        dispatch({ type: DELETE_AI_CHATBOT_QUESTION });
    });
};

export const deleteAiChatbotQuestions = (screen, ids, filtered = {}) => {
    let params = {};

    // Nasetujeme filter
    _.forEach(filtered, (value, key) => {
        params = { ...params, ...{ [`filter_${key}`]: value } };
    });

    return dispatch => request(`/ai-chatbot-questions/multiDelete/${ids}`, params).then(response => {
        const { status } = response.data;

        if (status === 'error') {
            screen.showSnackbar('error', __('Nepodarilo sa zmazať otázky'));
            return;
        }

        screen.showSnackbar('success', __('Otázky boli zmazané'));

        dispatch({ type: DELETE_AI_CHATBOT_QUESTIONS });
    });
};

export const cleanAiChatbotQuestions = () => ({ type: CLEAN_AI_CHATBOT_QUESTIONS });
